(ns ncr.widgets.datev
  (:require
   [cljs.core.async :as async :refer-macros [go] :refer [<!]]
   [clojure.core.match :refer [match]]
   [uix.core.alpha :as uix]
   [com.rpl.specter :as sp]
   [ncr.etc.util :as u]
   [ncr.etc.modal :as m]
   [ncr.widgets.core :as w]
   [ncr.widgets.pf :as wpf]
   [ncr.etc.alert :as a]
   [ncr.etc.pf :as pf]
   [ncr.backend :as b]
   [ncr.etc.pubsub :as ps]
   [ncr.fragment.attachment-label :as attachments]))

(defn use-datev
  ([] (use-datev {}))
  ([{:keys [withDocTypes fragments]}]
   (let
     [state
      (ps/sub-reducer-map! [:loading]
        {::set (fn [_ new-state] new-state)
         ::reload
         (fn [state]
           (go
             (u/if-ok
               [{:keys [datev_status fragments]}
                (<!
                  (b/!multi-query
                    (merge
                      {:datev_status
                       [:datev_status
                        {:withDocTypes (true? withDocTypes)}
                        [:status :sandbox :data]]}

                      (when (seq fragments)
                        {:fragments
                         [:fragment_load_multiple
                          {:references fragments}
                          [:id :name :labels :folder :revoked :promotedHint :owner :creator
                           [:cachedAttachments [:id :fileName :auxdata]]]]}))))]
               (ps/pub!
                 [::set
                  [:ok
                   (merge
                     {:datev
                      (update datev_status :data u/transit-read)}
                     (when (some? fragments)
                       {:fragments
                        (->> fragments
                          (sp/transform [sp/ALL :cachedAttachments sp/ALL :auxdata] u/transit-read)
                          (sp/setval [sp/ALL (sp/map-key :cachedAttachments)] :attachments))}))]])
               (ps/pub! [::set [:error datev_status]])))
           (ps/pub! [::set [:loading]])
           state)})]

     (uix/with-effect []
       (ps/pub! [::reload]))
     state)))

(defn- dialog-inner [{:keys [submit header title] :as props} & children]
  [m/c-modal
   (w/merge-props
     {:id :datev-dialog
      :title title
      :header header
      :variant :large
      :is-overflow-visible true
      :actions
      [[pf/c-button
        {:variant :primary
         :is-disabled (nil? submit)
         :on-click submit}
        "Upload"]
       [pf/c-button
        {:variant :link :on-click #(m/close! nil)} "Cancel"]]}
     (select-keys props [:ref :id]))
   (into [:<>] children)])

(defn- c-select-folder [{:keys [selection on-select]} types]
  [wpf/c-pf-select
   {:width 300
    :position :right
    :selections selection
    :on-select on-select}
   types])

(defn- c-toolbar [{:keys [types type on-select-type attachments-count]}]
  [pf/c-toolbar
   [pf/c-toolbar-content
    [pf/c-toolbar-group {:variant :icon-button-group}
     [pf/c-toolbar-item
      [c-select-folder
       {:selection type
        :on-select
        (fn [_ t _]
          (on-select-type t))}
       types]]]

    [pf/c-toolbar-group {:variant :icon-button-group}
     [w/c-toolbar-button
      {:icon :reload
       :on-click #(ps/pub! [::reload])
       :tooltip "Reload"}]]

    (when (> attachments-count 0)
      [pf/c-toolbar-group
       {:alignment {:default :align-right}}
       [pf/c-toolbar-item {:variant :label}
        (u/format "%d documents selected for upload" attachments-count)]])]])

(defn- dmd [attachment]
  (get-in attachment [:auxdata :datev]))

(defn- selectable? [attachment]
  (let [dmd (dmd attachment)]
    (or (nil? dmd) (= (:status dmd) :error))))

(defn- dialog-form [{:keys [types fragments selected-attachments selected-type on-select-type on-toggle-attachment]}]
  (let [single? (= (count fragments) 1)]
    [pf/c-panel {:is-scrollable true}
     [pf/c-panel-header
      {:class :pf-u-p-0
       :variant :light
       :sticky :top
       :aria-label "Toolbar"}
      [c-toolbar
       {:types types
        :type selected-type
        :on-select-type
        on-select-type
        :attachments-count
        (count selected-attachments)}]]

     [pf/c-panel-main {:max-height "600px"}
      [pf/c-panel-main-body
       [pf/c-data-list {:class-name :ncr-c-datev :is-compact true}
        (into [:<>]
          (map
            (fn [{:keys [name attachments]}]
              [pf/c-data-list-item {:class-name :ncr-c-datev__fragment}
               [pf/c-data-list-item-row
                [pf/c-data-list-item-cells {}
                 [pf/c-data-list-cell
                  [pf/l-flex {:direction :column}
                   (when-not single?
                     [pf/l-flex-item {:class-name :ncr-c-datev__fragment__name} name])
                   (into [:<>]
                     (map
                       (fn [{:keys [fileName id] :as attachment}]
                         [pf/l-flex {:class-name (pf/class-name [:ncr-c-datev__attachment (when-not single? :pf-u-pl-md)])}
                          (if (selectable? attachment)
                            (let [selected? (contains? selected-attachments id)]
                              [pf/c-checkbox
                               {:id (str "cb_" id)
                                :class-name :ncr-c-datev__attachment__checkbox
                                :is-checked selected?
                                :on-change
                                #(on-toggle-attachment id)}])
                            [attachments/c-datev-icon {:show-tooltip? true} (dmd attachment)])
                          [:span fileName]])
                       attachments))]]]]])
            fragments))]]]]))

(defn- c-upload-body [{:keys [fragments types]}]
  (let
    [types
     (->> types
       (map
         (fn [{:keys [name] :as type}]
           (assoc type :label name :id name)))
       (sort-by :name))

     no-type
     (or
       (->> types
         (filter #(= "ohne Belegtyp" (get % :name))) first)
       (first types))

     fragments
     (->> fragments
       (filter
         (fn [{:keys [folder]}]
           (nil? folder)))
       (filter
         (fn [{:keys [attachments]}]
           (seq attachments))))

     default-selected
     (->> fragments
       (map
         (fn [{:keys [attachments]}]
           (when (= 1 (count attachments))
             (let [{:keys [id] :as attachment} (first attachments)]
               (when (selectable? attachment)
                 id)))))
       (filter some?))

     selected-attachments
     (uix/state
       (into #{} default-selected))

     selected-type
     (uix/state no-type)

     submit
     (fn [_]
       (m/close!
         (->> fragments
           (mapcat
             (fn [{:keys [attachments] :as fragment}]
               (->> attachments
                 (map
                   (fn [attachment]
                     (let
                       [attachment-id (:id attachment)
                        type (:name @selected-type)]
                       (when (contains? @selected-attachments attachment-id)
                         {:attachment-id attachment-id
                          :fragment-id (:id fragment)
                          :type type})))))))
           (filter some?))))]

    ; FIXME wtf is use-submit-form
    #_(let
        [ref (uix/ref)
         modal-id :datev-dialog])

    ;(m/use-submit-form modal-id ref submit)

    (let
      [single? (= (count fragments) 1)]

      [dialog-inner
       {:title (if single? (u/format "%s - Upload to DATEV" (-> fragments first :name)) "Upload to DATEV")
        :submit
        (when-not (empty? @selected-attachments) submit)
        #_:id #_modal-id
        #_:ref #_ref}
       (if (seq fragments)
         [dialog-form
          {:types types
           :fragments fragments
           :selected-attachments @selected-attachments
           :selected-type @selected-type
           :on-select-type
           #(reset! selected-type %)
           :on-toggle-attachment
           #(swap! selected-attachments
              (if (contains? @selected-attachments %) disj conj) %)}]
         [dialog-inner {:title "Upload to DATEV"}
          [pf/c-empty-state {}
           "No Fragments with Uploadable Attachments"]])])))

(defn- c-dialog-body [fragments]
  (match @(use-datev {:withDocTypes true :fragments (map :id fragments)})
    [:error e]
    [dialog-inner {}
     [pf/c-empty-state
      [:span "Error: " (pr-str e)]]]

    [:ok
     {:datev {:status status :data {:document-types doc-ts}}
      :fragments fragments'}]
    (if (or (not= status "CONNECTED") (nil? doc-ts))
      [dialog-inner {}
       [pf/c-empty-state {} "Error: DATEV setup incomplete"]]
      [c-upload-body {:fragments fragments' :types doc-ts}])

    [:loading]
    [dialog-inner {}
     [w/c-empty-progress "Loading..."]]))

(defn schedule-upload! [_ fragments]
  (go
    (if-let [upload (<! (m/!modal #'c-dialog-body fragments))]
      (<!
        (a/!operation
          {:operation-title "Scheduling DATEV upload"
           :success-title "DATEV Upload scheduled"}
          (b/!mutation
            [:schedule_job
             {:jobName "datev/upload"
              :data
              (u/transit-write
                {:attachments
                 (mapv
                   (fn [{:keys [fragment-id attachment-id type]}]
                     {:attachment/id attachment-id
                      :reference/id fragment-id
                      :doc-type type})
                   upload)})}])))
      [:error :cancel])))

#_(defn sql [_])

#_(defn c-bookmark [{:keys [slug]}]
    [:button
     {:form-action
      #(-> {:insert-into :bookmarks :values [{:slug slug}]} sql <!)}
     [:bookmark-icon]])


